/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteSkill} from '../api'

export const useMutationDeleteSkill = createReactQueryMutationHook('deleteSkill', deleteSkill)
